import { Box } from "@mui/material";
import { AgNavBar, Fullscreen } from "../mui-components/AgNavBar";



export function Layout(){
    return <Box sx={{height:"100vh", bacgroundColor : "#EEEFF4"}}>
      <Fullscreen/>
    </Box>
}